module.exports = __webpack_public_path__ + "img/iStock-1186956422.6bb8286c.png";